(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/pay-footer.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/pay-footer.js');

'use strict';

const {
  ReactButton: Button,
  ReactDots: Dots
} = svs.ui;
const {
  useContext
} = React;
const {
  utils: {
    buildProlongHref
  },
  constants: {
    PROLONG_SUBSCRIPTION
  }
} = svs.numbergames.prolong_game.common;
const {
  handlePay,
  handleSubscriptionPay
} = svs.numbergames.prolong_game.pay;
const {
  ProlongContext
} = svs.numbergames.prolong_game.context;
const {
  trackClickChange
} = svs.numbergames.prolong_game.analytics;
const PayFooter = () => {
  const prolongContext = useContext(ProlongContext);
  const {
    drawCount,
    price,
    accountBalance,
    accountIsSyndicate,
    wager: {
      wagerId,
      productName,
      properties
    },
    getAfterChangeReturnUrl
  } = prolongContext;
  const prolongHref = buildProlongHref({
    productName,
    wagerId,
    syndicateId: properties === null || properties === void 0 ? void 0 : properties.syndicateId,
    getAfterChangeReturnUrl
  });
  return React.createElement(Dots, {
    branding: "tur",
    className: "padding-bottom-2 margin-top"
  }, React.createElement("div", {
    className: "margin-xs-h-1 margin-md-h-2 padding-top"
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-between"
  }, React.createElement("p", null, accountBalance && !isNaN(drawCount) && React.createElement(React.Fragment, null, accountIsSyndicate ? 'Vårt' : 'Ditt', ' ', "saldo:", ' ', accountBalance, ' ', "kr"))), drawCount === PROLONG_SUBSCRIPTION ? React.createElement(Button, {
    block: true,
    disabled: price < 1,
    focus: true,
    onClick: event => handleSubscriptionPay(event, prolongContext)
  }, "Starta: ", price, " kr / vecka") : React.createElement(Button, {
    block: true,
    disabled: price < 1,
    focus: true,
    onClick: () => handlePay(prolongContext)
  }, "Betala", ' ', price, ' ', "kr"), React.createElement("div", {
    className: "u-text-center margin-top-1"
  }, React.createElement("a", {
    href: prolongHref,
    onClick: event => trackClickChange(event, {
      prolongHref,
      productName
    })
  }, React.createElement("span", {
    className: "fc-navy u-text-decoration-underline f-medium"
  }, "\xC4ndra")))));
};
setGlobal('svs.numbergames.prolong_game.components.PayFooter', PayFooter);

 })(window);